import type { FC } from "react";
import React from "react";
import ListUserSelectedConditions from "src/ui/components/ListUserSelectedConditions/ListUserSelectedConditions";

const TextWithKeywords: FC<{ text?: string }> = ({ text = "" }) => {
  return (
    <>
      {text.includes("__user_conditions__") ? (
        <ListUserSelectedConditions />
      ) : (
        text
      )}
    </>
  );
};

export default TextWithKeywords;
